import { ImsObject } from 'app/shared/collections/ims_object';
import { LocationStatsResource } from 'app/shared/resources';
import {
    FIELD_SCHEMAS__TYPE_CENSORED_SYSTEM,
    FIELD_SCHEMAS__TYPE_LON_LAT,
    FIELD_SCHEMAS__TYPE_NUMBER,
    STAT_DEFINITION__PARENT_TYPE_ASSET,
    StatDefinition,
} from './StatDefinition';
import * as colors from 'app/shared/utilities/ims_color';
import { createGradientColorConfig } from 'app/shared/utilities/ims_color';

export const IMS_TYPE__LOCATION_STAT = 'location_stat';

export const locationStatDefinition: StatDefinition = {
    name: IMS_TYPE__LOCATION_STAT,
    display_name: 'Location Stat',
    description: 'Location stats for Assets',
    data_frequency: 10,
    parent_type: STAT_DEFINITION__PARENT_TYPE_ASSET,
    field_schemas: {
        location: {
            display_name: 'Location',
            description: 'The longitude and latitude',
            units: {
                suffix: ' degrees',
            },
            type: FIELD_SCHEMAS__TYPE_LON_LAT,
            color_config: createGradientColorConfig(0, colors.IMS_LIME, 10, colors.IMS_RED),
        },
        altitude: {
            display_name: 'Altitude',
            units: {
                suffix: ' m',
            },
            type: FIELD_SCHEMAS__TYPE_NUMBER,
            color_config: createGradientColorConfig(0, colors.IMS_LIME, 10, colors.IMS_RED),
        },
        speed: {
            display_name: 'Speed',
            units: {
                suffix: ' km/h',
            },
            type: FIELD_SCHEMAS__TYPE_NUMBER,
            color_config: createGradientColorConfig(0, colors.IMS_LIME, 30, colors.IMS_RED),
        },
        heading: {
            display_name: 'Heading',
            units: {
                suffix: ' degrees',
            },
            type: FIELD_SCHEMAS__TYPE_NUMBER,
            color_config: createGradientColorConfig(0, colors.IMS_LIME, 360, colors.IMS_RED),
        },
        system: {
            display_name: 'Source',
            units: {
                suffix: '',
            },
            type: FIELD_SCHEMAS__TYPE_CENSORED_SYSTEM,
            color_config: createGradientColorConfig(0, colors.IMS_LIME, 360, colors.IMS_RED),
        },
    },
};

export class LocationStats extends ImsObject {
    constructor(resource = new LocationStatsResource()) {
        super(IMS_TYPE__LOCATION_STAT, resource);
    }

    set location(location: [number, number]) {
        this.resource.location = location;
    }

    get location(): [number, number] {
        return this.resource.location;
    }

    set timestamp(timestamp: string) {
        this.resource.timestamp = timestamp;
    }

    get timestamp(): string {
        return this.resource.timestamp;
    }

    set assetId(assetId: number) {
        this.resource.asset_id = assetId;
    }

    get assetId(): number {
        return this.resource.asset_id;
    }

    set altitude(altitude: number) {
        this.resource.altitude = altitude;
    }

    get altitude(): number {
        return this.resource.altitude;
    }

    set heading(heading: number) {
        this.resource.heading = heading;
    }

    get heading(): number {
        return this.resource.heading;
    }

    set speed(speed: number) {
        this.resource.speed = speed;
    }

    get speed(): number {
        return this.resource.speed;
    }
}
